import { Routes } from '@angular/router';
import { UserGuard } from './core/guards';
import { FullLayout } from './layouts/full-layout/full-layout';

export const routes: Routes = [
  {
    path: '',
    component: FullLayout,
    canActivate: [UserGuard],
    loadChildren: () => import('./pages/page.routes').then((m) => m.pageRoutes)
  },
  {
    path: '',
    loadChildren: () => import('./authentication/auth.routes').then((m) => m.AuthRoutes)
  },
  {
    path: '**',
    loadComponent: () => import('./pages/page-not-found/page-not-found').then((m) => m.PageNotFound)
  }
];
